export const TRANSCRIPTION_LANGUAGE_OPTIONS: Array<{ label: string; value: string }> = [
    { label: "Auto", value: "auto" },
    { label: "English", value: "en" },
    { label: "Spanish", value: "es" },
    { label: "French", value: "fr" },
    { label: "German", value: "de" },
    { label: "Chinese (Mandarin, Simplified)", value: "zh" },
    { label: "Portuguese", value: "pt" },
    { label: "Italian", value: "it" },
    { label: "Bulgarian", value: "bg" },
    { label: "Catalan", value: "ca" },
    { label: "Czech", value: "cs" },
    { label: "Danish", value: "da" },
    { label: "Dutch", value: "nl" },
    { label: "Estonian", value: "et" },
    { label: "Finnish", value: "fi" },
    { label: "Flemish", value: "nl-BE" },
    { label: "German (Switzerland)", value: "de-CH" },
    { label: "Greek", value: "el" },
    { label: "Hindi", value: "hi" },
    { label: "Hungarian", value: "hu" },
    { label: "Romanian", value: "ro" },
    { label: "Russian", value: "ru" },
    { label: "Slovak", value: "sk" },
    { label: "Swedish", value: "sv" },
    { label: "Thai", value: "th" },
    { label: "Turkish", value: "tr" },
    { label: "Ukrainian", value: "uk" },
];

// Backwards-compatible map shape used by existing dialogs.
export const TRANSCRIPTION_LANGUAGES: Record<string, string> = TRANSCRIPTION_LANGUAGE_OPTIONS.reduce(
    (acc, option) => {
        acc[option.label === "Auto" ? "Auto Detect" : option.label] = option.value;
        return acc;
    },
    {} as Record<string, string>,
);
